import { ReactElement, useRef } from "react"
import { useNavigate } from "react-router"
import { Button } from "@/components/wrappers/Aria/AriaWrapper.tsx"
import { Flex, View } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import Briefcase from "@spectrum-icons/workflow/Briefcase"

export type SideBarItemProps = {
  label: string
  icon?: ReactElement
  route: string
}

export function SideBarItem({
  label,
  icon,
  route,
}: SideBarItemProps) {
  const navigate = useNavigate()
  const childRef = useRef<HTMLButtonElement>(null)

  function onPress() {
    void navigate(route)
  }

  return (
    <Button
      ref={childRef}
      className={"w-full py-0.5 text-left dark:hover:bg-cyan-700"}
      onPress={onPress}
    >
      <Flex
        direction="row"
        justifyContent="start"
        alignItems="center"
        width="100%"
        wrap="nowrap"
        minHeight="size-400"
      >
        <View paddingStart="size-130" paddingEnd="size-130">
          {icon && icon}
          {!icon && <Briefcase size="M" />}
        </View>
        <View>
          <span className="mr-4 text-nowrap">{label}</span>
        </View>
      </Flex>
    </Button>
  )
}
